import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../common/types';
import { useUserTokenDecoded } from '../../redux/slices/appInfo/hooks';

interface TeamAcceptSignedInAsProps {
  className?: string;
}

const bold = (chunks: React.ReactNode[]) => <b className="text-body">{chunks}</b>;

/** "Signed in as jonas@nightshift.fm", with the address in bold (designs f1 and q). */
const TeamAcceptSignedInAsComponent: React.FC<TeamAcceptSignedInAsProps> = ({ className }) => {
  const intl = useIntl();
  const email = useUserTokenDecoded()?.email ?? '';
  if (email === '') {
    return null;
  }
  return (
    <p className={`small text-muted ${className ?? ''}`}>
      {intl.formatMessage(
        { id: 'app.sml.team.accept.signedInAsBold', defaultMessage: 'Signed in as <b>{email}</b>' },
        { email, b: bold }
      )}
    </p>
  );
};

export const TeamAcceptSignedInAs = TypedMemo(TeamAcceptSignedInAsComponent);
